import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { UnauthorizedEntityModel } from '../models/unauthorized-entity.model';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UnauthorizedEntityService {
  constructor(private api: ApiService) {}

/**
 * Updates Unauthorized Entity details collected from initial registation form
 * @param entity - The entity details to update
 */
  updateUnauthorizedEntity(entity: UnauthorizedEntityModel) {
    return this.api.postWithCustomHeaders(`unauthorized/entity/update`, entity, this.getUnauthorizedEntityHeader());
  }

  /**
   * Get Unauthorized entity to check whether GUID details have been submitted
   * @returns 
   */
  getUnauthorizedEntity() {
    return this.api.getAnySingleWithHeaders<UnauthorizedEntityModel>(
      `unauthorized/entity`,
      this.getUnauthorizedEntityHeader()
    ).pipe(map(response => response.body as UnauthorizedEntityModel));
  }

  /**
   * Gets UnauthorizedEntityGuid from session storage and returns in a HttpHeaders object
   * @returns HttpHeader with UnauthorizedEntityGuid
   */
  getUnauthorizedEntityHeader(): HttpHeaders {
    return this.api.getHeaders().set('UnauthorizedEntityGuid', sessionStorage.getItem('UnauthorizedEntityGuid') ?? '');
  }
}
